import { environment } from './../../../../environments/environment';
import { Component, OnInit, OnDestroy, HostListener, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EnterMobileComponent } from '../enter-mobile/enter-mobile.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { WalletService } from 'src/app/core/services/wallet.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';
import { LoggedLandingPageService } from 'src/app/core/services/logged-landing-page.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Location } from '@angular/common';
import { PlansService } from 'src/app/core/services/plans.service';
import { IfStmt } from '@angular/compiler';
import { UploadSpaceModalComponent } from '../../wipod/upload-publication/upload-space-modal/upload-space-modal.component';

declare var Stripe: any;
@Component({
  selector: 'app-add-tokens',
  templateUrl: './add-tokens.component.html',
  styleUrls: ['./add-tokens.component.scss']
})
export class AddTokensComponent implements OnInit, OnDestroy {

  @Input() sourceCart;
  @Input() userId?: any;
  @Input() tabType?: any;
  @Input() sourcePlan;
  @Input() sourceGift;
  @Input() inputTokens;
  @Input() fromStripeBack;
  addTokenForm: FormGroup;
  submitted = false;
  handler: any = null;
  userTokens: any;
  tokens: any;
  sessionId: any;
  success_url: any;
  cancel_url: any;
  tokenValueInUSD = 0;
  tokenRate = 10;
  maxTokens = 0;
  source: any = 'addToken';
  private ngUnsubscribe = new Subject();
  currentUrl: string;
  defaultToken = null;
  modalDivHidden = false;
  is_save: boolean = true;
  creditCards;
  selectedCard;
  cardSelection: boolean = false;
  showCardSelection: boolean = false;
  contentLoader: boolean = false;
  @Input() cardSelectedIdBack;
  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private _walletService: WalletService,
    private _loggedLandingPageService: LoggedLandingPageService,
    private _authService: AuthService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private location: Location,
    private _plansService: PlansService,
    private _router: Router
  ) {
    this.success_url = '/wallet?status=true';
    this.cancel_url = '/wallet?status=false';
  }

  ngOnInit() {


    this.route.params.subscribe(params => {
      if (params) {
      }
    });

    this.addTokenForm = this.formBuilder.group({
      token: ['', Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.INTEGER_PATTERN)])],
      currencyCode: ['usd', [Validators.required]]
    });

    this._walletService.loadTokens().subscribe(
      (response: any) => {
        if (response.success) {
          this.userTokens = response.data.account;
        }

      }, (error: any) => {

      });
    this._loggedLandingPageService.convertToken(1).pipe(takeUntil(this.ngUnsubscribe)).subscribe((response) => {
      if (response.success) {
        this.tokenRate = response.data.converted_amount;
        if (this.addTokenForm.get('token').value) {
          this.tokenValueInUSD = this.addTokenForm.get('token').value / this.tokenRate;
        }
        this.maxTokens = Math.floor(999999.99 * this.tokenRate);
        this.addTokenForm.controls['token'].setValidators(Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.INTEGER_PATTERN), Validators.max(this.maxTokens), Validators.min(5)]));
        if (this.inputTokens) {
          this.addTokenForm.get('token').setValue(this.inputTokens);
        }
      }
    });
    this.initTokenConverter();
    this.fetchCreditCards();
  }

  closeDialog() {
    this.activeModal.dismiss();
  }

  openAddAccountModal() {
    this.closeDialog();
    this.modalService.open(EnterMobileComponent, { centered: true });
  }

  addToken() {
    this.submitted = true;
    if (this.addTokenForm.invalid) {
      return;
    }
    if (this.creditCards.length) {
      this.cardSelection = true;
      document.querySelector(".modal").scrollTop = 0;
      if (document.querySelector(".add-token")) {
        document.querySelector(".add-token").scrollTop = 0;
      }
    } else {
      this.onSubmit();
    }
  }

  onSubmit(sendCard?) {
    //const url = this.route.snapshot['_routerState'].url;
    // const url = this.router.routerState.snapshot.url;
    const url = this.location.path();

    const userData = this._authService.getCurrentUser();

    this.submitted = true;
    if (this.addTokenForm.invalid) {
      return;
    }

    let sourceFinal = this.source;
    if (this.sourceGift == 'gift') {
      this.source = 'gift';
      sourceFinal = 'addToken';
    } else if (this.sourceGift == 'transfer') {
      this.source = 'transfer';
      sourceFinal = 'addToken';
    }
    const param: any = {
      ...this.addTokenForm.value,
      'source': sourceFinal
    };

    if (this.sourceCart == 'cart' || this.sourceCart == 'giftCart' || this.sourceCart == 'subscriptionModal') {
      let user_id = '';
      if (this.userId) {
        user_id = `&user_id=${this.userId}`
      }
      let tabType = '';
      if (this.tabType) {
        tabType = `&tabType=${this.tabType}`;
      }
      if (url.includes("?")) {
        this.success_url = url + '&source=' + this.sourceCart + '&amount=' + this.addTokenForm.get('token').value + user_id + tabType;
        this.cancel_url = url + '&source=' + this.sourceCart + '&status=false&amount=' + this.addTokenForm.get('token').value + user_id + tabType;
      } else {
        this.success_url = url + '?source=' + this.sourceCart + '&amount=' + this.addTokenForm.get('token').value + user_id + tabType;
        this.cancel_url = url + '?source=' + this.sourceCart + '&status=false&amount=' + this.addTokenForm.get('token').value + user_id + tabType;
      }
    }
    else if (this.source == 'addToken') {
      this.success_url = '/wallet?status=true&amount=' + this.addTokenForm.get('token').value;
      this.cancel_url = '/wallet?status=false&amount=' + this.addTokenForm.get('token').value;
    } else if (this.source == 'gift') {
      this.success_url = '/wallet?status=true&open=gift&amount=' + this.addTokenForm.get('token').value;
      this.cancel_url = '/wallet?status=false&amount=' + this.addTokenForm.get('token').value;
    } else if (this.source == 'transfer') {
      this.success_url = '/wallet?status=true&open=transfer&amount=' + this.addTokenForm.get('token').value;
      this.cancel_url = '/wallet?status=false&amount=' + this.addTokenForm.get('token').value;
    }
    if (this.sourcePlan == 'plan') {
      this.success_url = '/wallet?status=true&open=plan&amount=' + this.addTokenForm.get('token').value;
      this.cancel_url = '/wallet?open=plan';
    }
    if (this.sourcePlan == 'addons') {
      this.success_url = '/wallet?status=true&open=addons&amount=' + this.addTokenForm.get('token').value;
      this.cancel_url = '/wallet?open=addons';
    }

    param.success_url = this.success_url;
    param.cancel_url = this.cancel_url;

    if (this.selectedCard && sendCard) {
      param.credit_card_id = this.selectedCard.id;
    } else {
      param.is_save = (!this.creditCards) ? true : this.is_save;
    }

    if (this.selectedCard) {
      param.cancel_url += '&card_id=' + this.selectedCard.id;
      param.success_url += '&card_id=' + this.selectedCard.id;
    }
    if (!userData.user.phone || userData.user.phone == 'undefined') {
      this.openOtpModal(param);
    } else {
      this.redirectToStripe(sendCard);
    }
    return;
  }

  saveCardOrNot() {
    this.is_save = !this.is_save;
  }

  redirectToStripe(sendCard?) {
    this.spinner.show();
    const params = {
      ...this.addTokenForm.value,
      success_url: this.success_url,
      cancel_url: this.cancel_url,

    }
    if (this.selectedCard && sendCard) {
      params.credit_card_id = this.selectedCard.id;
    } else {
      params.is_save = (!this.creditCards) ? true : this.is_save
    }
    if (this.selectedCard) {
      params.cancel_url += '&card_id=' + this.selectedCard.id;
      params.success_url += '&card_id=' + this.selectedCard.id;
    }
    this._walletService.addTokens(params).subscribe(
      (response: any) => {
        // console.log(response);
        // return
        if (response.success) {
          this.closeDialog();
          if (response.data.session_id) {
            this.sessionId = response.data.session_id;
            this.pay();
          } else if (response.data.url) {
            window.location.href = response.data.url;
          } else {
            window.location.href = window.location.origin + this.success_url;
            // this._router.navigateByUrl(this.success_url);
          }
          // this.pay();
        } else if (response.errors) {
          this.spinner.hide();
          const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
          modalRef.componentInstance.contentAccessError = response.errors;
          modalRef.componentInstance.isRedirectRequired = false;
        } else {
          // this._router.navigateByUrl(this.cancel_url);
          window.location.href = window.location.origin + this.success_url;
        }
      }, (error: any) => {
        // this._toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
      });
  }

  openOtpModal(tokenData) {
    this.closeDialog();
    const modalRef = this.modalService.open(EnterMobileComponent, { scrollable: false, centered: true });
    modalRef.componentInstance.giftUserData = tokenData;
    modalRef.result.then((result) => {
      if (result === 'success') {
        this.redirectToStripe();
      }
    }, (reason) => {
    });
  }

  async pay() {
    const stripe = Stripe(environment.stripe_publication_key);
    const { error } = await stripe.redirectToCheckout({
      sessionId: this.sessionId
    });
    stripe.redirectToCheckout({
      sessionId: this.sessionId
    }).then(function (result) {
      alert("Not working")
    });
  }

  /**
   * Init token converter on page loads
   *
   * @memberof AddTokensComponent
   */
  initTokenConverter() {

    this.addTokenForm.get('token').valueChanges.subscribe((val) => {
      if (this.tokenRate) {
        this.tokenValueInUSD = val / this.tokenRate;
      }

    })
    // following code can be used when there is multiple currency
    // this.addTokenForm.get('token').valueChanges.pipe(
    //   startWith(0),
    //   debounceTime(250),
    //   distinctUntilChanged(),
    //   switchMap(val => {
    //     if (val) {
    //       return this._loggedLandingPageService.convertToken(val);
    //     } else {
    //       this.tokenValueInUSD = 0;
    //     }
    //   }),
    //   takeUntil(this.ngUnsubscribe)
    // ).subscribe(
    //   (response: any) => {
    //     if (response.success) {
    //       this.tokenValueInUSD = (this.addTokenForm.get('token').value * this.addTokenForm.get('token').value) / response.data.converted_amount;
    //     }
    //   }, (error: any) => {

    //   });
  }

  /**
   * restrict e . + -
   *
   * @param {*} event
   * @returns
   * @memberof AddTokensComponent
   */
  restrictNumeric(event) {
    const restrictKeycodes = [101, 46, 43, 45];

    //firefox solution
    event = event || window.event;
    var charCode = (typeof event.which == "undefined") ? event.keyCode : event.which;
    var charStr = String.fromCharCode(charCode);

    if (!charStr.match(/^[0-9]+$/))
      event.preventDefault();

    if (restrictKeycodes.includes(event.keyCode) || event.target.value.length > 11) {
      return false;
    }
  }

  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    e.preventDefault();
  }

  fetchCreditCards() {
    this.contentLoader = true;
    this._plansService.getCards().subscribe(
      (response: any) => {
        this.contentLoader = false;
        if (response.success) {
          this.creditCards = response.data.credit_cards;
          if (this.creditCards.length) {
            if (this.inputTokens && this.fromStripeBack) {
              this.cardSelection = true;
            }
            this.creditCards.sort(function (a, b) {
              return b.is_default_card - a.is_default_card;
            });
            this.selectedCard = this.creditCards.find((element) => {
              return element.is_default_card == true;
            });
            if (this.cardSelectedIdBack) {
              const index = this.creditCards.findIndex((element) => {
                return element.id == this.cardSelectedIdBack;
              });
              if (this.creditCards[index])
                this.selectedCard = this.creditCards[index];
            }
          }

        }
      }, (error) => {
        this.contentLoader = false;
      })
  }

  selectDefault(item) {
    this.selectedCard = item;
    this.showCardSelection = false;
    document.querySelector(".modal").scrollTop = 0;
    if (document.querySelector(".add-token")) {
      document.querySelector(".add-token").scrollTop = 0;
    }
  }

  formatMonth(deg) {
    return ('0' + deg).slice(-2)
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
